import { colors } from '@/components/atoms/colors'
import MahimaLogo from '@/components/atoms/mahimaLogo'
import Link from 'next/link'

const LogoButton = ({ color = colors.olive }) => {
  const base =
    'absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[90px] md:w-[165px] aspect-[12/5] z-[3]'
  return (
    <Link scroll={false} href="/" className={base}>
      <MahimaLogo color={color} className="w-full h-full" />
    </Link>
  )
}

export default LogoButton
